import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'app-delete-item',
    imports: [],
    templateUrl: './delete-item.component.html',
    styleUrl: './delete-item.component.scss'
})
export class DeleteItemComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              private dialogRef: MatDialogRef<DeleteItemComponent>) {}
  closeDialog(res: boolean){
    this.dialogRef.close(res);
  }

}
